import { render, staticRenderFns } from "./DomainMetricContainer.vue?vue&type=template&id=6517e2a8&"
import script from "./DomainMetricContainer.vue?vue&type=script&lang=js&"
export * from "./DomainMetricContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports